import { BidInventoryItem, BidItem } from 'remarketing-angular-library';

interface BidModalItemDetailModel {
  modelYear: number;
  make: string;
  model: string;
  trim: string;
  vin: string;
}

export interface BidModalItemModel {
  openingPrice: boolean;
  currentAmount: number;
  auctionItemUuid: string;
  buyerOeUuid: string;
  financeSourceUuid: string;
  financeSourceAch: boolean;
  localDelivery: boolean;
  itemDetail: BidModalItemDetailModel;
  autoBidStatus?: string;
}

export class BidModalItem implements BidModalItemModel {
  openingPrice: boolean;
  currentAmount: number;
  auctionItemUuid: string;
  buyerOeUuid: string;
  financeSourceUuid: string;
  financeSourceAch: boolean;
  localDelivery: boolean;
  itemDetail: BidModalItemDetailModel;
  autoBidStatus?: string;

  constructor(init: BidModalItemModel) {
    this.openingPrice = init.openingPrice;
    this.currentAmount = init.currentAmount;
    this.auctionItemUuid = init.auctionItemUuid;
    this.buyerOeUuid = init.buyerOeUuid;
    this.financeSourceUuid = init.financeSourceUuid;
    this.financeSourceAch = init.financeSourceAch;
    this.localDelivery = init.localDelivery;
    this.itemDetail = init.itemDetail;
    this.autoBidStatus = init.autoBidStatus;
  }

  static fromBidInventoryItem(item: BidInventoryItem): BidModalItem {
    const {
      openingPrice,
      currentAmount,
      auctionItemUuid,
      buyerOeUuid,
      financeSourceAch,
      financeSourceUuid,
      localDelivery,
      itemDetail: { modelYear, make = '', model = '', trim = '', vin = '' },
      autoBidStatus
    } = item;
    return new BidModalItem({
      openingPrice,
      currentAmount,
      auctionItemUuid,
      buyerOeUuid,
      financeSourceUuid,
      financeSourceAch,
      localDelivery,
      itemDetail: {
        modelYear,
        make,
        model,
        trim,
        vin
      },
      autoBidStatus
    });
  }

  static fromBidItem(item: BidItem): BidModalItem {
    const {
      openingPrice,
      currentAmount,
      auctionItemUuid,
      buyerOeUuid,
      financeSourceUuid,
      financeSourceAch,
      localDelivery,
      itemDetail: { modelYear, make = '', model = '', trim = '', vin = '' },
      autoBidStatus
    } = item;
    return new BidModalItem({
      openingPrice,
      currentAmount,
      auctionItemUuid,
      buyerOeUuid,
      financeSourceUuid,
      financeSourceAch,
      localDelivery,
      itemDetail: {
        modelYear,
        make,
        model,
        trim,
        vin
      },
      autoBidStatus
    });
  }

  get title(): string {
    const { modelYear, make, model, trim } = this.itemDetail;
    return `${modelYear ? `${modelYear} ` : ''}${make} ${model} ${trim} - VIN `;
  }

  get titleSimple(): string {
    const { modelYear, make, model, trim } = this.itemDetail;
    return `${modelYear ? `${modelYear} ` : ''}${make} ${model} ${trim} `;
  }

  model(): BidModalItemModel {
    return {
      openingPrice: this.openingPrice,
      currentAmount: this.currentAmount,
      auctionItemUuid: this.auctionItemUuid,
      buyerOeUuid: this.buyerOeUuid,
      financeSourceUuid: this.financeSourceUuid,
      financeSourceAch: this.financeSourceAch,
      localDelivery: this.localDelivery,
      itemDetail: this.itemDetail
    };
  }
}
